export const byKey = (data = [], keyProp = 'id') => {
  const dict = {};
  const keys = [];
  for (let i = 0; i < data.length; i += 1) {
    const key = data[i][keyProp];
    dict[key] = { ...data[i] };
    keys.push(key);
  }
  return { dict, keys };
};

export function toLookup(data = []) {
  return data.reduce((acc, item) => {
    acc[item] = true;
    return acc;
  }, {});
}
